// Module
var code = "<abm-text-card ng-model=\"vm.value\" placeholder=\"{{vm.placeholder}}\" on-save=\"vm.onChange(vm.value)\" ng-disabled=\"!vm.field.is_editable\" ng-required=\"vm.field.is_required\" ng-readonly=\"vm.readonly\" ng-cloak> <label ng-bind=\"vm.field.name\"></label> </abm-text-card> ";
// Exports
module.exports = code;